module.exports = __webpack_public_path__ + "img/2025-07-21a_4.ae674362.jpg";